<template>
    <a-row>
        <a-row type="flex" justify="start" class="routesTitle" align="middle">
            <a-col class="ml4">Routes</a-col>
            <a-col style="margin: 0 auto;">
                <a-row type="flex" justify="start" align="middle">
                    <a-col>
                        From: <a-date-picker size="small" v-model="fromTime" @change="changeFromTime" style="width: 120px;"/>
                    </a-col>
                    <a-col class="ml4">
                        To: <a-date-picker size="small" v-model="toTime" style="width: 120px;"/>
                    </a-col>
                    <a-col class="ml4 sbxs">
                        <a-icon type="search" size="small" @click="init"/>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
        <a-row style="border: 1px solid gray;padding:4px">
            <a-row type="flex" justify="space-between">
                <a-col>
                    <a-row type="flex" justify="start" align="middle">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('roleGe.Add') }}</span>
                            </template>
                            <img class="sbxs mllr4" src="../../../assets/img/ss-add.png"  width="22" height="22" @click="add">
                        </a-tooltip>
                        <a-popconfirm
                                :title="$t('pubGicSet.AreyoudeleTask')"
                                :okText="$t('pubGicSet.Yes')"
                                :cancelText="$t('pubGicSet.No')"
                                @confirm="delRoute"
                        >
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('roleGe.Delete') }}</span>
                                </template>
                                <img class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                            </a-tooltip>
                        </a-popconfirm>
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>Refresh</span>
                            </template>
                            <img class="sbxs mllr4" style='margin-top: 2px' src="../../../assets/img/ss-refresh.png" width="22" height="20" @click="init">
                        </a-tooltip>
                        <a-dropdown >
                            <a class="ant-dropdown-link">
                                <img class="sbxs mllr4" src="../../../assets/img/more.png"  width="22" height="20">
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item style="font-size: 12px" @click="comfirm">Confirm</a-menu-item>
                                <a-menu-item style="font-size: 12px" @click="uncomfirm">Unconfirm</a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </a-row>
                </a-col>
                <a-col>
                    <a-pagination
                            :pageSizeOptions="routes.pageSizeOptions"
                            :showTotal="total => `Total of ${routes.pagingTotal}  Records`"
                            size="small"
                            :total="routes.pagingTotal"
                            v-model="routes.currentVal"
                            :pageSize.sync="routes.pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                    />
                </a-col>
            </a-row>
            <a-row class="mt4" id="routesDrop">
                <vxe-table
                    stripe
                    resizable
                    border
                    class="mytable-style"
                    show-header-overflow
                    show-overflow
                    highlight-hover-row
                    @cell-dblclick="dbClickEdit"
                    @cell-click="clickRow"
                    size="mini"
                    ref="routesTableRef"
                    :cell-class-name="cellClassName"
                    :height="routesHeight"
                    :data="tableData">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;"></span>
                    </template>
                    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                    <vxe-table-column min-width="100" field="routeId" title="Route No." sortable></vxe-table-column>
                    <vxe-table-column min-width="100" field="status" title="Status" sortable>
                        <template v-slot="{ row }">{{ row.status | filterSatus}}</template>
                    </vxe-table-column>
                    <vxe-table-column min-width="100" field="routeDate" :formatter="formatTime" title="Route Date" sortable></vxe-table-column>
                    <vxe-table-column min-width="100" field="vehicle" title="Vehicle"></vxe-table-column>
                    <vxe-table-column min-width="100" field="driver" title="Driver"></vxe-table-column>
                    <vxe-table-column min-width="100" field="numberOfWaypoint" title="No. of waypoints"></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-row>
        <a-modal v-model="visible" title="Routes" width="50%" :maskClosable="false">
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveRoute">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="form">
                <a-row>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Route Type" class="genericFrom">
                            <a-select
                                    style="width: 100%"
                                    size="small"
                                    v-decorator="['type',
                                         {
                                              initialValue: routesFromVal.type,
                                               rules: [{ required: true, message: 'type Id is Required' }]
                                         }
                                     ]">
                                <a-select-option :value="item.CODE" v-for="item in localData.TMS_ROUTE_TYPE">{{item.CODE_DESC}}</a-select-option>
                            </a-select>

                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Route Date" class="genericFrom">
                            <a-date-picker
                                    size="small"
                                    style="width: 100%;"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                    v-decorator="['expStartDt', {
                                        initialValue:routesFromVal.expStartDt ?  moment(routesFromVal.expStartDt, 'YYYY-MM-DD HH:mm:ss') : moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                                        rules: [{ required: true, message: 'Route Date is Required' }]
                                     }]"
                            />
                        </a-form-item>
                    </a-col>
                    <!--<a-col :span="12">-->
                    <!--<a-form-item label="Status" class="genericFrom">-->
                    <!--<a-input size="small"-->
                    <!--v-decorator="['status',-->
                    <!--{-->
                    <!--initialValue: routesFromVal.status,-->
                    <!--}-->
                    <!--]"-->
                    <!--/>-->
                    <!--</a-form-item>-->
                    <!--</a-col>-->
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Vehicle" class="genericFrom">
                            <a-select
                                    style="width: 100%"
                                    @change="vehicleIdChange"
                                    size="small"
                                    v-decorator="['vehicleId',
                                         {
                                              initialValue: routesFromVal.vehicleId,
                                               rules: [{ required: true, message: 'Vehicle is Required' }]
                                         }
                                     ]">
                                <a-select-option :value="item.VEHICLE_ID" v-for="item in vehicleDropdownInfo">{{item.LICENSE_PLATE}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Driver" class="genericFrom">
                            <a-select
                                    style="width: 100%"
                                    size="small"
                                    v-decorator="['driverId',
                                         {
                                              initialValue: routesFromVal.driverId,
                                               rules: [{ required: true, message: 'Driver is Required' }]
                                         }
                                     ]">
                                <a-select-option :value="item.USER_NAME" v-for="item in driverDropdownInfo">{{item.DISP_NAME}}</a-select-option>
                            </a-select>

                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Route Rule" class="genericFrom">
                            <a-input size="small" v-decorator="['routeRuleId', {
                                initialValue: routesFromVal.routeRuleId,
                               /* rules: [
                                        { required: true, message: 'Route Rule is Required' }
                                      ]*/
                            }]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Address 1" class="genericFrom">
                            <a-input size="small" v-decorator="['depotAddress1', { initialValue: routesFromVal.depotAddress1}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Address 2" class="genericFrom">
                            <a-input size="small" v-decorator="['depotAddress2', { initialValue: routesFromVal.depotAddress2}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Address 3" class="genericFrom">
                            <a-input size="small" v-decorator="['depotAddress3', { initialValue: routesFromVal.depotAddress3}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot City" class="genericFrom">
                            <a-input size="small" v-decorator="['depotCity', { initialValue: routesFromVal.depotCity}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Suburb" class="genericFrom">
                            <a-input size="small" v-decorator="['depotSuburb', { initialValue: routesFromVal.depotSuburb}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Province" class="genericFrom">
                            <a-input size="small" v-decorator="['depotProvince', { initialValue: routesFromVal.depotProvince}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Country" class="genericFrom">
                            <a-input size="small" v-decorator="['depotCountry', { initialValue: routesFromVal.depotCountry}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Depot Postal Code" class="genericFrom">
                            <a-input size="small" v-decorator="['depotPostalCode', { initialValue: routesFromVal.depotPostalCode}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Remark" class="genericFrom">
                            <a-textarea :rows="2" v-decorator="['remark', {
                                initialValue: routesFromVal.remark}]"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>

        <a-modal
                :visible="vehiclePopupVisible"
                width="60%"
                @cancel="cancelVehicleModal"
        >
            <template slot="footer">
                <a-button type="primary" @click="saveOrdersToRouteHeader" size="small" >{{ $t('publicLang.Save') }}</a-button>
                <a-button type="primary" @click="cancelVehicleModal" size="small">{{ $t('publicLang.Cancel')}}</a-button>
            </template>
            <a-form :form="form" >
                <a-row :gutter="24">
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Vehicle" class="genericFrom">
                            <a-select
                                    style="width: 100%"
                                    @change="vehicleIdChange"
                                    size="small"
                                    v-decorator="['vehicleId',
                                         {
                                              initialValue: routesFromVal.vehicleId,
                                               rules: [{ required: true, message: 'Vehicle is Required' }]
                                         }
                                     ]">
                                <a-select-option :value="item.VEHICLE_ID" v-for="item in vehicleDropdownInfo">{{item.LICENSE_PLATE}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :offset="1" :span="11">
                        <a-form-item label="Driver" class="genericFrom">
                            <a-select
                                    style="width: 100%"
                                    size="small"
                                    v-decorator="['driverId',
                                         {
                                              initialValue: routesFromVal.driverId,
                                               rules: [{ required: true, message: 'Driver is Required' }]
                                         }
                                     ]">
                                <a-select-option :value="item.USER_NAME" v-for="item in driverDropdownInfo">{{item.DISP_NAME}}</a-select-option>
                            </a-select>

                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>
        <a-modal v-model="dragResultInfo" :title="$t('publicLang.AlertMessage')" :footer="null" width="30%">
            <a-alert>
                <div slot="description" style="height: 30vh;overflow-y: auto;">
                    <a-row v-for="(item,index) in dragResultData"  :style="{background: index%2 ==0 ? '#efefef': '#fff',padding: '0 10px'}">
                         <span>{{item}}</span>
                     </a-row>
                </div>
            </a-alert>
            <a-row  type="flex" justify="end">
                <a-button class="mt4" type="primary" size="small" @click="closeDragResultPopup">{{ $t('publicLang.Cancel')}}</a-button>
            </a-row>
        </a-modal>

    </a-row>

</template>
<script>
    import Sortable from "sortablejs";
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from 'moment'
    import axios from "axios";
    import { mapState } from "vuex";
    import XEUtils from "xe-utils";
    export default{
        computed: {
            ...mapState(["tmsDrag"]),
        },
        props:{
            routesHeight: {
                type: Number,
                default: ()=>{
                  return 100
                }
            },
        },
        data(){
            return{
                tableData: [],
                routes: {
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal:0,
                    currentVal: 1,
                    pagingSize: 10
                },
                visible: false,
                form:this.$form.createForm(this),
                routesFromVal: {}, // 表单当前展示内容 edit 双击
                selectRow: {}, // 单机当前数据
                vehicleDropdownInfo:[],// 下拉数据
                driverDropdownInfo: [], // 下拉数据
                fromTime: moment(new Date(), 'YYYY-MM-DD'),
                toTime: moment(new Date(), 'YYYY-MM-DD'),
                localData: {},
                vehiclePopupVisible:false,
                dragResultInfo:false,
                dragResultData:[]
            }
        },
        watch:{
            tmsDrag(val){
                console.log(val);
                let that = this;
               // let routesTableRef = this.$refs.routesTableRef
                if(val.flag==='orders'){
                    let routesDrop = document.getElementById('routesDrop');
                    if(null === val.expDeliveryDate || undefined === val.expDeliveryDate){
                        that.$customMessage.warning("Missing Exp Delivery Date");
                        that.init();
                        return;
                    }
                    let currentTime = new Date();
                    currentTime = moment(currentTime).format('YYYY-MM-DD');
                    let expDeliveryDate = moment(val.expDeliveryDate).format('YYYY-MM-DD');
                    console.log("currentTime:"+currentTime+",val.expDeliveryDate:"+expDeliveryDate);
                    if(expDeliveryDate<currentTime){
                        that.$customMessage.warning("Exp Delivery Date cannot early than today");
                        that.init();
                        return;
                    }
                    //拖拽orders
                    setTimeout(()=>{
                        that.showVehicleModal();
                    },1000)
                }else {
                    //拖拽Waypoints
                    setTimeout(()=>{
                        ajax.post(api.TMSMERGEROUTE,val).then(res=>{
                            if(res.code == 200){
                                that.$parent.cleardata()
                                that.$message.success(res.msg);
                            }
                        })
                    },1000)
                }
            }
        },
        created () {
            this.rowDrop()
            this.init()
            this.localData = JSON.parse(sessionStorage.getItem('localData'))
        },
        beforeDestroy () {
            if (this.sortable) {
                this.sortable.destroy()
            }
        },
        filters: {
            filterSatus(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.TMS_ROUTE_STATUS
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            }
        },
        methods: {
            moment,
//            comfirm
            formatTime ({cellValue}) {
                return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
            },
            changeFromTime(){
                if(!this.toTime){
                    this.toTime = this.fromTime;
                }
            },
            comfirm(){
                let len = this.$refs.routesTableRef.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    for(let i in len){arr.push(len[i].uid)}
                    let params = {
                        routeHeaderUids: arr.toString()
                    }
                    this.$emit('emitheaderUid',null)
                    this.$emit('routeNo',null)
                    ajax.post(api.TMSCOMFIRMROUTE,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.init()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
            uncomfirm(){
                let len = this.$refs.routesTableRef.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    for(let i in len){arr.push(len[i].uid)}
                    let params = {
                        routeHeaderUids: arr.toString()
                    }
                    this.$emit('emitheaderUid',null)
                    this.$emit('routeNo',null)
                    ajax.post(api.TMSUNCOMFIRMROUTE,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.init()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
//            获取table 选中
            getTableCkeck(){
                let len = this.$refs.routesTableRef.getCheckboxRecords()
                return len
            },
            //      分页
            onShowSizeChange(current, pageSize) {
                this.routes.currentVal = current;
                this.routes.pagingSize = pageSize;
                this.init()
            },
            //      分页
            tableChangePage(current) {
                this.routes.currentVal = current;
                this.init()
            },
//            删除
            delRoute(){
                let len = this.$refs.routesTableRef.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    for(let i in len){
                        arr.push(len[i].uid)
                    }
                    let params = {
                        routeHeaderUids: arr.toString()
                    }
                    ajax.post(api.TMSDELETEROUTEHEADER,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.init()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
//            保存route 表单
            saveRoute(){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let params = values
                        values.expStartDt = values['expStartDt'].format('YYYY-MM-DD HH:mm:ss')
                        if(this.routesFromVal.uid){
                            values.uid = this.routesFromVal.uid
                        }
                        ajax.post(api.TMSSAVEROUTEHEADER,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.visible = false
                                this.init()
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }else{
                        for(let i in err){
                            this.$customMessage.warning(err[i].errors[0].message)
                        }
                    }
                });
            },
            //            新增按钮
            add(){
                this.visible = true
                this.routesFromVal = {}
                this.form.resetFields();
                ajax.get(api.TMSGETDRIVERDROPDOENINFO,{driverId:null}).then(res=>{
                    this.driverDropdownInfo = res.data
                })

            },
//            双击编辑
            dbClickEdit({row}){
                this.visible = true
                this.form.resetFields();
//                查询当前数据的内容
                ajax.get(api.TMSGETROUTE,{id:row.uid}).then(res=>{
                    this.routesFromVal = res.data
                    ajax.get(api.TMSGETDRIVERDROPDOENINFO,{driverId: this.routesFromVal.driverId}).then(res=>{
                        this.driverDropdownInfo = res.data
                    })
                })
            },
//            弹窗下拉数据
            selectData(){
                ajax.get(api.TMSGETVEHICLEDROPDONINFO).then(res=>{
                    this.vehicleDropdownInfo = res.data
                })
            },
//            vehicle下拉请求driverId
            vehicleIdChange(val){
                let arr = this.vehicleDropdownInfo
                let id = null
                for(let i in arr){
                    if(arr[i].VEHICLE_ID == val){
                        id = arr[i].DRIVER_ID
                    }
                }
                this.form.setFieldsValue({['driverId']:null})
                ajax.get(api.TMSGETDRIVERDROPDOENINFO,{driverId:id}).then(res=>{
                    this.driverDropdownInfo = res.data
                    if(this.driverDropdownInfo.length > 0){
                        this.form.setFieldsValue({['driverId']: this.driverDropdownInfo[0].USER_NAME})
                    }
                })
            },
//            单机请求下个table数据
            clickRow({row,column}){
                if(column.title != undefined){
                    this.$refs.routesTableRef.setCheckboxRow([this.selectRow], false)
                    this.$emit('emitheaderUid',row.uid)
                    this.$emit('routeNo',row.routeId)
                    this.selectRow = row
                    this.$refs.routesTableRef.setCheckboxRow([this.selectRow], true)
                }
            },
//            初始化数据
            init(type){
                if(this.vehicleDropdownInfo.length == 0){
                    this.selectData()
                }
                let params = {
                    pageNumber:this.routes.currentVal,
                    pageSize: this.routes.pagingSize,
                }
                if(this.fromTime){
                    params.from = moment(this.fromTime).format('YYYY-MM-DD')
                }
                if(this.toTime){
                    params.to = moment(this.toTime).format('YYYY-MM-DD')
                }
                /*
                if(null!=this.fromTime && null!=this.toTime){
                    if(this.fromTime>this.toTime){
                        this.$customMessage.warning("From Date cannot greater than To Date.");
                        return;
                    }
                }*/

                ajax.get(api.TMSGETROUTES,params).then(res=>{
                    if(res.code == 200){
                       this.tableData = res.data
                       this.routes.pagingTotal = res.total
                       this.$parent.ordersInit()
                       if(this.tableData.length > 0){
                           this.selectRow = this.tableData[0]
                           this.$refs.routesTableRef.setCheckboxRow([this.tableData[0]], true)
                           this.$emit('emitheaderUid',this.selectRow.uid)
                           this.$emit('routeNo',this.selectRow.routeId)
                       }else{
                           this.$emit('emitheaderUid',null)
                           this.$emit('routeNo',null)
                       }
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            //            单击当前行变色
            cellClassName({ row }) {
                if (row === this.selectRow) {
                    return "rorClass";
                }
            },
            rowDrop () {
                let that = this
                this.$nextTick(() => {
                    let routesTableRef = this.$refs.routesTableRef
                    let routesDrop = document.getElementById('routesDrop')

                       //拖拽orders
                        this.sortable = Sortable.create(routesDrop, {
                            handle: '.drag-btn',
                            group: {name:'od'},
                            sort: false,
                        })
                        //拖拽Waypoints
                        this.sortable = Sortable.create(routesDrop, {
                            handle: '.drag-btn',
                            group: {name:'rw'},
                            sort: false,
                      })
                })
            },
            showVehicleModal(){
                this.vehiclePopupVisible = true;
            },
            cancelVehicleModal(){
                this.vehiclePopupVisible = false;
                let that = this
                that.form.resetFields();
            },
            saveOrdersToRouteHeader(){
                let that = this
                that.form.validateFields((err, values) => {
                    if(!err){
                        let arr = that.vehicleDropdownInfo
                        let vehicle = null;
                        for(let i in arr){
                            if(arr[i].VEHICLE_ID == values.vehicleId){
                                vehicle = arr[i].LICENSE_PLATE
                            }
                        }
                        let params = {
                            doHeaderUids:that.tmsDrag.doHeaderUids,
                            vehicle : vehicle
                        }
                        ajax.post(api.TMSDRAGORDERSTOROUTEHEADER,params).then(res=>{
                            if(res.code == 200){
                               // that.$message.success(res.msg);
                                this.init();
                                this.cancelVehicleModal();
                                let data = res.msg
                                //console.log("data:"+data)
                               // data = data.split("<br>");
                                this.dragResultData = data.split("<br>");
                               // console.log("this.dragResultData:"+this.dragResultData)
                                this.dragResultInfo=true;
                            }else{
                                that.$customMessage.warning(res.msg);
                            }
                        })
                    }

                })

            },
            closeDragResultPopup(){
                this.dragResultData = [];
                this.dragResultInfo = false;
            },

        }
    }
</script>
<style>
    #routesDrop>tr{
        display: none;
    }
    .mytable-style .vxe-body--column.rorClass {
        background-color: #73459d;
        color: #fff;
    }
    .ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn{
        color: blue;
    }
</style>
